import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing[6]};
    gap: ${({ theme }) => theme.spacing[4]};
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[3]};
    align-items: center;
`;

export const AdminNotice = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[4]};
    background: ${({ theme }) => theme.color.yellow200};
    border: 1px solid ${({ theme }) => theme.color.yellow200};
    border-radius: ${({ theme }) => theme.radius.main};
    color: ${({ theme }) => theme.color.black200};
    font-size: ${({ theme }) => theme.font.size.small};
`;

export const SelectorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    max-width: 320px;
`;
